import { UsersApi } from '@quadminds/client-apis/users';
import { STORK_USERS_API_URL } from '../config';
import { isStorkPlatform } from '../utils/utils';

const USERS_API_URL = process.env['NX_USERS_API_URL'];

if (!USERS_API_URL) {
    throw new Error('NX_USERS_API_URL environment variable is required but not set');
}

const createUsersApi = (stork: boolean) =>
    new UsersApi({
        baseURL: stork ? STORK_USERS_API_URL : USERS_API_URL,
        withCredentials: true,
        debug: true,
    });

let cachedApi: UsersApi | null = null;
let cachedIsStork: boolean | null = null;

export const usersApi = new Proxy({} as UsersApi, {
    get(_target, prop) {
        const stork = isStorkPlatform();
        if (cachedApi === null || stork !== cachedIsStork) {
            cachedApi = createUsersApi(stork);
            cachedIsStork = stork;
        }
        const value = cachedApi[prop as keyof UsersApi];
        if (typeof value === 'function') {
            return value.bind(cachedApi);
        }
        return value;
    },
}) as UsersApi;
